import { param2Obj } from '@/utils/util';
export default {
  data() {
    return {};
  },
  directives: {
    'tab-change': {
      // 绑定时读取query是否有action字段
      bind(_, binding) {
        const param = param2Obj(window.location.href);
        if (param.active) {
          binding.value({ action: 'setActiveName', key: binding.arg }, param.active);
        }
      },
      // 切换时query写入action字段
      update(_, binding) {
        // setTimeout（0） 等待dom完成后进行操作
        setTimeout(() => {
          const param = param2Obj(window.location.href);
          // 获取dom
          const queryList = document.querySelectorAll('.el-tabs__item');
          for (let index = 0; index < queryList.length; index++) {
            const item = queryList[index];
            if (item.className.indexOf('is-active') !== -1) {
              const activeName = item.id.split('-')[1];
              // 防止重复调用push方法
              if (param.active !== activeName) {
                binding.value({ action: 'setPath' }, activeName);
              }
            }
          }
        }, 0);
      },
    },
  },
  methods: {
    setActiveName({ action, key }, activeName) {
      // 写入tabs默认值
      if (action === 'setActiveName') {
        this[key] = activeName;
      } else {
        // 使用 replace 方法防止产生记录
        const param = param2Obj(window.location.href);
        this.$router.replace({
          query: {
            ...param,
            active: activeName,
          },
        });
      }
    },
  },
};
